import { useEffect } from "react";
import Heading from "@/components/tpr/Heading/Heading";
import { BreadcrumbItem, BreadcrumbLink } from "@/components/ui/breadcrumb";
import { useBreadcrumb } from "@/contexts/breadcrumbContext";

// import { Item, ItemActions, ItemContent, ItemDescription, ItemTitle } from "@/components/ui/item";
// import { useMember } from "@/contexts/memberContext";

const TermsView = () => {
  // const { member } = useMember();

  const { setBreadcrumb } = useBreadcrumb();

  useEffect(() => {
    setBreadcrumb(
      <>
        <BreadcrumbItem className="text-sm text-gray-600 truncate max-w-[125px] md:max-w-none">
          <BreadcrumbLink href="#">Terms and Conditions</BreadcrumbLink>
        </BreadcrumbItem>
      </>,
    );
    return () => setBreadcrumb(null);
  }, [setBreadcrumb]);

  return (
    <div>
      <div className="px-4 min-h-[80vh]">
        <div className="mb-8 mt-8">
          <Heading title={`Terms and Conditions`} />
        </div>

        <section className="text-gray-600 body-font">
          <div className="container px-5 py-12 mx-auto flex flex-wrap">
            <div className="text-base">
              <h1 className="text-2xl font-bold text-gray-900 py-8">Our agreements with you</h1>

              <p className="text-base mb-4">
                The following agreements will apply to you when you use our booking system:
              </p>

              <ul className="max-w-md space-y-1 text-gray-500 list-disc list-inside dark:text-gray-400">
                <li>
                  <a href="/terms/acceptable-use-policy" className="text-purple-600 hover:cursor-pointer">
                    Acceptable Use Policy
                  </a>
                </li>
                <li>
                  <a href="/terms/privacy-policy" className="text-purple-600 hover:cursor-pointer">
                    Privacy Policy
                  </a>
                </li>
                <li>
                  <a href="/terms/cookies-policy" className="text-purple-600 hover:cursor-pointer">
                    Cookies &amp; Similar Technologies Policy
                  </a>
                </li>
              </ul>

              <p className="text-base mt-4 mb-4">
                These agreements do not directly relate to our products which have their own terms and conditions. If
                you wish to get a copy of any agreement you may have had with us in the past or currently, you can{" "}
                contact us.
              </p>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default TermsView;
